/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import DataTable, { Column } from "components/DataTable";
import { StatusChip } from "components/StatusChip";
import { useAuth } from "contexts/AuthContext";
import { useTranslation } from "contexts/i18nContext";
import { useHasRole } from "contexts/AuthContext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  fetchComplaint,
  fetchComplaintByAdminUnit,
  fetchComplaintForProsecutor,
} from "services/prosecutorDecipilineService";
import { Complaints } from "types";
import { DateView } from "utils/helper";
import { ROLES } from "utils/roles";
import avatarImage from "../../images/avatar.png";

export default function AccusedRequests() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useTranslation();

  const isProsecutor = useHasRole([ROLES.INSPECTION_PROSECUTOR]);
  const byAdminUnit = useHasRole([
    ROLES.INSPECTION_COORDINATOR,
    ROLES.INSPECTION_REGISTRAR,
    ROLES.INSPECTION_DIRECTOR,
    ROLES.ZONAL_COUNCIL_OFFICE_HEAD,
    ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
  ]);

  const [complaints, setComplaints] = useState<Complaints[]>([]);
  const [activeTab] = useState<string>("All");
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState("");

  useEffect(() => {
    const loadComplaints = async () => {
      setIsInitialLoading(true);
      try {
        const api = isProsecutor
          ? fetchComplaintForProsecutor(user.user_id)
          : byAdminUnit
            ? fetchComplaintByAdminUnit(user.admin_unit)
            : fetchComplaint();
        const data = await api;

        setComplaints(data || []);
        // setError("");
      } catch (err) {
        setComplaints([]);
        // setError("Failed to load complaint.");
      } finally {
        setIsInitialLoading(false);
      }
    };
    loadComplaints();
  }, [isProsecutor, byAdminUnit, user?.user_id, user?.admin_unit]);

  const columns: Column<Complaints>[] = [
    {
      header: t("applicationNumber"),
      accessor: "accused_prosecutor_working_id",
      render: (row) => {
        if (typeof row.application_number === "string") {
          return row.application_number || "—";
        }
        return row.application_number || "—";
      },
    },
    {
      header: t("accusedProsecutor"),
      accessor: "accused_prosecutor_name",
      render: (row) => (
        <div className="flex items-center gap-3">
          <img src={avatarImage} className="w-10 h-10 rounded-full grayscale" />
          <span>{row.accused_prosecutor_name}</span>
        </div>
      ),
      widthClass: "w-1/5",
    },
    {
      header: t("assignedTo"),
      accessor: "assignedTo",
      render: (row) => row.assigned_prosecutor ?? "—",
    },
    {
      header: t("appliedDate"),
      accessor: "reception_date",
      render: (row) => DateView(row.reception_date),
    },
    {
      header: t("status"),
      accessor: "status",
      render: (row) => <StatusChip status={row?.status || ""} />,
    },
    { header: t("phoneNumber"), accessor: "accused_prosecutor_phone" },
    {
      header: t("assign"),
      accessor: "id",
      render: (row) =>
        row.assigned_prosecutor ? (
          <span className="text-green-600 font-medium">{t("assigned")}</span>
        ) : (
          <button disabled className="px-4 py-1 text-sm bg-gray-200 rounded ">
            {t("assign")}
          </button>
        ),
    },
    {
      header: t("action"),
      accessor: "action",
      render: (row: any) => (
        <button
          onClick={() =>
            navigate(`/accused-complaint/${row?.uu_id}`, {
              state: row,
            })
          }
          className="px-3 py-1 text-sm bg-black text-white rounded hover:bg-gray-800 transition"
        >
          {t("open")}
        </button>
      ),
    },
  ];

  return (
    <div className=" mx-auto flex flex-col space-y-4">
      <h1 className="text-2xl font-semibold text-gray-700 flex items-center gap-2 mb-5">
        <span>⚖</span>
        {t("accusedComplaintRequests")}
      </h1>

      {/* Header: Tabs + Add button */}
      {/* <div className="w-full flex flex-wrap items-center justify-between gap-4 mb-5">
        <TabNav active={activeTab} tabs={tabs} onSelect={setActiveTab} />
      </div> */}

      <DataTable
        title={t("serviceRequestTable")}
        columns={columns}
        isLoading={isInitialLoading}
        loadingText="Loading"
        data={[...(complaints || [])]
          .sort(
            (a, b) =>
              new Date(b?.createdAt ?? "").getTime() -
              new Date(a?.createdAt ?? "").getTime(),
          )
          ?.filter((obj) => activeTab === "All" || obj.status === activeTab)
          ?.filter((obj) => obj.has_accused)
          ?.filter((obj) => {
            if (!searchQuery.trim()) return true;

            const query = searchQuery.toLowerCase();
            const accusedName =
              obj.accused_prosecutor_name?.toLowerCase() || "";
            const licenseNumber =
              typeof obj.accused_prosecutor === "string"
                ? obj.accused_prosecutor.toLowerCase()
                : obj.accused_prosecutor?.working_id?.toLowerCase() || "";

            return accusedName.includes(query) || licenseNumber.includes(query);
          })}
        rowKey={(row) => row.uu_id}
        onSearch={(q) => setSearchQuery(q)}
      />
    </div>
  );
}
